import SystemNotificationCrud from "../components/system-notifications/SystemNotificationCrud";

const SystemNotificationPage = () => {
  return <SystemNotificationCrud />;
};

export default SystemNotificationPage;
